import { isVisible } from '@church/nextjs-ui/website/forms';
import type { ClientForm } from './types';
import { waiverOf } from './questions';

/**
 * The pure half of the finish sheet (components/FinishSheet.tsx): which
 * screens somebody gets and what is still owed on each. Same rules as the
 * registration sheet, so a form that sheet would accept is accepted here.
 */

/** Fields signed once at the end rather than asked per person. */
function atTheEnd(form: ClientForm | null): Set<number> {
  const w = waiverOf(form);
  return new Set([w?.doc.id, w?.agree?.id, w?.signature?.id].filter(Boolean) as number[]);
}

/** Whether this form has anything to ask besides its waiver. */
export function asksQuestions(form: ClientForm | null): boolean {
  if (!form) return false;
  const end = atTheEnd(form);
  return form.fields.some(
    (f) => !f.hidden && !f.parentId && f.kind !== 'instructions' && !end.has(f.id)
  );
}

/** The first required, visible question still blank, waiver aside, by the words the form used. */
export function stillOwed(form: ClientForm | null, answers: Record<string, string>): string | null {
  if (!form) return null;
  const end = atTheEnd(form);
  for (const f of form.fields) {
    if (f.kind === 'instructions' || f.kind === 'file' || f.parentId || end.has(f.id)) continue;
    if (f.required && isVisible(form, f, answers) && !(answers[f.id] ?? '').trim())
      return f.title || f.label;
  }
  return null;
}
